import TrackerManagement from './TrackerManagement'

class UserTrackerAdd extends TrackerManagement {

}

export default UserTrackerAdd